export default "/bundles/assets/photo7_92d1f5e72b2d97e101643ae9fe27baa9.png";